common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initNavbar();
        this.addTrianglesToBlocks();
    },

    initNavbar()
    {
        // Give parent .active when has a .active subitem
        $('.navbar-nav .dropdown-menu > .dropdown-item.active').each(function(){
            $(this).parents('.nav-item').find('.nav-link').addClass('active');
        });
    },

    addTrianglesToBlocks()
    {
        var excludeBeforeBlocks = [
            'Video',
        ];

        var excludeSubjectBlocks = [
            'Links Tekst Rechts Afbeelding met een schuine achtergrond'
        ];

        $('.canvas\\:\\:Canvas > div:not(:first-child)').each(function(){

            var $prevBlock = $(this).prev();
            var backgroundColor = $prevBlock.css('background-color');

            // Stop due to block height is below minimum?
            if($(this).height() < 200) {
                return;
            }

            // Stop due to is excluded?
            if(excludeBeforeBlocks.includes($prevBlock.data('name'))) {
                return;
            }

            // Stop due to is excluded?
            if(excludeSubjectBlocks.includes($(this).data('name'))) {
                return;
            }

            // Set main background-color when no background-color is found.
            if (backgroundColor == 'rgba(0, 0, 0, 0)') {
                backgroundColor = 'rgba(245 245 245)'
            }

            $(this)
                .prepend(
                    $('<div>')
                        .addClass('triangle')
                        .css('border-top-color', backgroundColor)
                );

        });

    },
});
